"use strict";
var React = require('react')
var Link = require('react-router')
var ListItemNews = require('./ListItemNews')
var getAdAction = require('../../actions/getAdAction');


var ListNewsComponent = React.createClass({
  componentDidMount(){

  },
  render: function() {
    return (
      <ListItemNews {...this.props}/>
    )
  }
});

module.exports=ListNewsComponent;



/** WEBPACK FOOTER **
 ** ./modules/components/App/ListNewsComponent.js
 **/